import { React } from "react";
import "../../components/CSS/Home/Post.css";
import "../../components/CSS/Sidebar/Left/Enroll.css";
// import SingleMeetupPost from "./SingleMeetupPost";
// import SingleLiveChatPost from "./SingleLiveChatPost";
//import SingleQnA from "./SingleQnA";
//import SingleLearningSession from "./SingleLearningSession";
//import SingleFanGroup from "./SingleFanGroup";
//import SingleAuditionPost from "./SingleAuditionPost";
import GuestSingleGeneralPost from "./GuestSingleGeneralPost";
import GuestSingleMeetupPost from "./GuestSingleMeetupPost";
import GuestSingleLiveChatPost from "./GuestSingleLiveChatPost";
import GuestSingleQnA from "./GuestSingleQnA";
import GuestSingleLearningSession from "./GuestSingleLearningSession";
import GuestSingleFanGroup from "./GuestSingleFanGroup";
import GuestSingleAuditionPost from "./GuestSingleAuditionPost";
// import SingleGeneralPost from "./SingleGeneralPost";

export default function GuestPostContent({ post }) {
    return (
        <>
            {post.type === "meetup" ? (
                <GuestSingleMeetupPost post={post}></GuestSingleMeetupPost>
            ) : post.type === "livechat" ? (
                <GuestSingleLiveChatPost post={post}></GuestSingleLiveChatPost>
            ) : post.type === "qna" ? (
                <GuestSingleQnA post={post}></GuestSingleQnA>
            ) : post.type === "learningSession" ? (
                <GuestSingleLearningSession post={post}></GuestSingleLearningSession>
            ) : post.type === "fangroup" ? (
                <GuestSingleFanGroup post={post}></GuestSingleFanGroup>
            ) : post.type === "audition" ? (
                <GuestSingleAuditionPost post={post}></GuestSingleAuditionPost>
            ) : post.type === "general" ? (
                <GuestSingleGeneralPost post={post}></GuestSingleGeneralPost>
            ) : (
                ""
            )}
        </>
    );
}
